module.exports = "//static.hsappstatic.net/conversations-embed/static-1.21486/sass/messagesWidgetShell.sass"